import React from 'react'

export default props => (
	<div class={`${props.responsive ? 'table-responsive p-0' : ''} ${props.striped ? 'table-striped' : ''}`} style={{ ...props.style, display: 'flex', overflowX: 'auto', fontSize: props.style && props.style.fontSize ? props.style.fontSize : 12 }}>
	    <table className='table table-hover table-head-fixed' style={{ marginBottom: props.style ? props.style.marginBottom : null }}>
			{props.children}
		</table>
	</div>
)
